import { motion } from "framer-motion";
import { Receipt, Leaf, Zap, Clock } from "lucide-react";

const benefits = [
  {
    icon: Receipt,
    title: "Reduce CEB Bills",
    desc: "Save significantly with smart solar PV design, yearly cashback potential with CEB.",
  },
  {
    icon: Leaf,
    title: "Eco-Friendly Energy",
    desc: "Cut carbon emissions & support Mauritius' green future.",
  },
  {
    icon: Zap,
    title: "Energy Independence",
    desc: "Produce your own power & reduce grid dependency.",
  },
  {
    icon: Clock,
    title: "24/7 System Monitoring",
    desc: "Smart inverters with real-time performance tracking.",
  },
];

export function Benefits() {
  return (
    <section id="benefits" className="py-24 sm:py-32 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-sm font-medium text-primary uppercase tracking-widest">
            Why Solar?
          </span>
          <h2 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight">
            The smart choice for your home & planet.
          </h2>
          <p className="mt-4 text-muted-foreground text-lg">
            Going solar with Green Volt means lower bills, cleaner energy, and total peace of mind.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {benefits.map((b, i) => (
            <motion.div
              key={b.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="group flex gap-4 p-6 rounded-2xl bg-card border border-border hover:border-primary/40 transition-all hover:shadow-elegant"
            >
              <div className="shrink-0 grid place-items-center w-12 h-12 rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition">
                <b.icon className="w-6 h-6" />
              </div>
              <div>
                <h3 className="font-semibold">{b.title}</h3>
                <p className="mt-1 text-sm text-muted-foreground leading-relaxed">{b.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
